export default "__VITE_ASSET__DM0nshcj__"